<app-menu>
    <h1 class="page-title">Site Updates</h1>

    <div *ngIf="permissionToLoad">
        <p class="info-text">
            New webpages are highlighted in <span class="accent">purple</span>.
        </p>

        <div *ngFor="let day of updatesText" class="release-card">
            <h2 class="release-date">
                {{day.date | date:'EEE, MMM d, yyyy':'UTC'}}
            </h2>

            <ul class="update-list">
                <li 
                    *ngFor="let update of day.updates" 
                    [class.new]="update.newRoute"
                >
                    <span class="route">Route: {{update.route}}</span>
                    <span class="desc"> — {{update.description}}</span>
                </li>
            </ul>
        </div>
    </div>

    <div *ngIf="!permissionToLoad" class="no-access">
        You do not have permission to view site updates.
    </div>

</app-menu>